// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dj0c","type":"styles_type__2gBep","choices":"styles_choices__2WKQe"};